import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const LegalPage = lazy(() => import('../pages/legal/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const CookiesPage = lazy(() => import('../pages/cookies/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/contacto',
    element: <ContactPage />,
  },
  {
    path: '/aviso-legal',
    element: <LegalPage />,
  },
  {
    path: '/politica-privacidad',
    element: <PrivacyPage />,
  },
  {
    path: '/politica-cookies',
    element: <CookiesPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
